// // import React, { useState } from 'react';

// // function RegisterForm({setActiveForm}) {
// //   const [formData, setFormData] = useState({
// //     surname: '',
// //     fullName: '',
// //     email: '',
// //     confirmEmail: '',
// //     designation: '',
// //     organizationType: '',
// //     organization: '',
// //     password: '',
// //     confirmPassword: '',
// //     notRobot: false
// //   });

// //   const handleInputChange = (e) => {
// //     const { name, value, type, checked } = e.target;
// //     setFormData(prev => ({
// //       ...prev,
// //       [name]: type === 'checkbox' ? checked : value
// //     }));
// //   };

// //   const handleSubmit = (e) => {
// //     e.preventDefault();
// //     // Handle form submission logic here
// //     console.log('Form submitted:', formData);
// //   };

// //   const handleClear = () => {
// //     setFormData({
// //       surname: '',
// //       fullName: '',
// //       email: '',
// //       confirmEmail: '',
// //       designation: '',
// //       organizationType: '',
// //       organization: '',
// //       password: '',
// //       confirmPassword: '',
// //       notRobot: false
// //     });
// //   };

// //   return (
// //     <>
// //       <div className="max-716 w-100 rounded-1 border p-4">
// //         <div className="font-24 font-700 mb-4 text-center text-primary-green text-uppercase border-bottom pb-2">Register</div>

// //         <form onSubmit={handleSubmit} className='row g-3'>
// //           <div className="col-12">
// //             <div className="row align-items-center">
// //               <div className="col-md-4">
// //                 <label className="form-label font-17 font-400 text-primary-green mb-0">Surname</label>
// //               </div>
// //               <div className="col-md-8">
// //                 <input
// //                   type="text"
// //                   className="form-control height-40 rounded-1 border-color-7D9199"
// //                   name="surname"
// //                   value={formData.surname}
// //                   onChange={handleInputChange}
// //                   required
// //                 />
// //               </div>
// //             </div></div>
// //           <div className="col-12"><div className="row align-items-center">
// //             <div className="col-md-4">
// //               <label className="form-label font-17 font-400 text-primary-green mb-0">Full Name</label>
// //             </div>
// //             <div className="col-md-8">
// //               <input
// //                 type="text"
// //                 className="form-control height-40 rounded-1 border-color-7D9199"
// //                 name="fullName"
// //                 value={formData.fullName}
// //                 onChange={handleInputChange}
// //                 required
// //               />
// //             </div>
// //           </div></div>
// //           <div className="col-12"><div className="row align-items-center">
// //             <div className="col-md-4">
// //               <label className="form-label font-17 font-400 text-primary-green mb-0">Email</label>
// //             </div>
// //             <div className="col-md-8">
// //               <input
// //                 type="email"
// //                 className="form-control height-40 rounded-1 border-color-7D9199"
// //                 name="email"
// //                 value={formData.email}
// //                 onChange={handleInputChange}
// //                 required
// //               />
// //             </div>
// //           </div></div>
// //           <div className="col-12"><div className="row align-items-center">
// //             <div className="col-md-4">
// //               <label className="form-label font-17 font-400 text-primary-green mb-0">Confirm Email</label>
// //             </div>
// //             <div className="col-md-8">
// //               <input
// //                 type="email"
// //                 className="form-control height-40 rounded-1 border-color-7D9199"
// //                 name="confirmEmail"
// //                 value={formData.confirmEmail}
// //                 onChange={handleInputChange}
// //                 required
// //               />
// //             </div>
// //           </div></div>
// //           <div className="col-12"><div className="row align-items-center">
// //             <div className="col-md-4">
// //               <label className="form-label font-17 font-400 text-primary-green mb-0">Designation</label>
// //             </div>
// //             <div className="col-md-8">
// //               <input
// //                 type="text"
// //                 className="form-control height-40 rounded-1 border-color-7D9199"
// //                 name="designation"
// //                 value={formData.designation}
// //                 onChange={handleInputChange}
// //                 required
// //               />
// //             </div>
// //           </div></div>
// //           <div className="col-12"><div className="row align-items-center">
// //             <div className="col-md-4">
// //               <label className="form-label font-17 font-400 text-primary-green mb-0">Organization Type</label>
// //             </div>
// //             <div className="col-md-8">
// //               <input
// //                 type="text"
// //                 className="form-control height-40 rounded-1 border-color-7D9199"
// //                 name="organizationType"
// //                 value={formData.organizationType}
// //                 onChange={handleInputChange}
// //                 required
// //               />
// //             </div>
// //           </div></div>
// //           <div className="col-12"><div className="row align-items-center">
// //             <div className="col-md-4">
// //               <label className="form-label font-17 font-400 text-primary-green mb-0">Organization</label>
// //             </div>
// //             <div className="col-md-8">
// //               <input
// //                 type="text"
// //                 className="form-control height-40 rounded-1 border-color-7D9199"
// //                 name="organization"
// //                 value={formData.organization}
// //                 onChange={handleInputChange}
// //                 required
// //               />
// //             </div>
// //           </div></div>
// //           <div className="col-12"><div className="row align-items-center">
// //             <div className="col-md-4">
// //               <label className="form-label font-17 font-400 text-primary-green mb-0">Password</label>
// //             </div>
// //             <div className="col-md-8">
// //               <input
// //                 type="password"
// //                 className="form-control height-40 rounded-1 border-color-7D9199"
// //                 name="password"
// //                 value={formData.password}
// //                 onChange={handleInputChange}
// //                 required
// //               />
// //             </div>
// //           </div></div>
// //           <div className="col-12"><div className="row align-items-center">
// //             <div className="col-md-4">
// //               <label className="form-label font-17 font-400 text-primary-green mb-0">Confirm Password</label>
// //             </div>
// //             <div className="col-md-8">
// //               <input
// //                 type="password"
// //                 className="form-control height-40 rounded-1 border-color-7D9199"
// //                 name="confirmPassword"
// //                 value={formData.confirmPassword}
// //                 onChange={handleInputChange}
// //                 required
// //               />
// //             </div>
// //           </div></div>
// //           <div className="col-12">
// //             <div className="row align-items-center">
// //               <div className="col-md-4"></div>
// //               <div className="col-md-8">
// //                 <div className='px-3 py-3 border-custom border-color-7D9199 rounded-1'>
// //                   <div className="form-check">
// //                   <input
// //                     className="form-check-input"
// //                     type="checkbox"
// //                     name="notRobot"
// //                     id="notRobot"
// //                     checked={formData.notRobot}
// //                     onChange={handleInputChange}
// //                     required
// //                   />
// //                   <label className="form-check-label text-primary-green font-400" htmlFor="notRobot">
// //                     I'm Not A Robot
// //                   </label>
// //                 </div>
// //                 </div>
// //               </div>
// //             </div></div>

// //           <div className="col-12">
// //             <div className="row align-items-center">
// //               <div className="col-md-4"></div>
// //               <div className="col-md-8">
// //                 <div className="row">
// //                   <div className="col-auto">
// //                     <button
// //                       type="submit"
// //                       className="btn btn-primary-green height-50 max-165 px-5 text-white w-100 fw-normal rounded-1"
// //                     >
// //                       Submit
// //                     </button>
// //                   </div>
// //                   <div className="col-auto">
// //                     <button
// //                       type="button"
// //                       className="btn btn-outline-primary-green height-50 max-165 px-5 w-100 fw-normal rounded-1"
// //                       onClick={handleClear}
// //                     >
// //                       Clear
// //                     </button>
// //                     </div>
// //                   <div className="col-auto">
// //                       <button
// //                       type="button"
// //                       className="btn height-50 px-2 border-0 fw-normal rounded-1"
// //                        onClick={()=>{setActiveForm("login")}}
// //                     >
// //                       Back
// //                     </button>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div></div>



// //         </form>
// //       </div>
// //     </>
// //   )
// // }

// // export default RegisterForm;





// // import React, { useState } from "react";
// // import { WebApiURL } from '../Constants/Constants';

// // function RegisterForm({ setActiveForm }) {
// //   const [formData, setFormData] = useState({
// //     surname: "",
// //     fullName: "",
// //     email: "",
// //     confirmEmail: "",
// //     designation: "",
// //     organizationType: "",
// //     organization: "",
// //     password: "",
// //     confirmPassword: "",
// //     notRobot: false
// //   });

// //   const [statusMessage, setStatusMessage] = useState("");
// //   const [isSubmitting, setIsSubmitting] = useState(false);

// //   const handleInputChange = (e) => {
// //     const { name, value, type, checked } = e.target;
// //     setFormData((prev) => ({
// //       ...prev,
// //       [name]: type === "checkbox" ? checked : value
// //     }));
// //   };

// //   const handleClear = () => {
// //     setFormData({
// //       surname: "",
// //       fullName: "",
// //       email: "",
// //       confirmEmail: "",
// //       designation: "",
// //       organizationType: "",
// //       organization: "",
// //       password: "",
// //       confirmPassword: "",
// //       notRobot: false
// //     });
// //     setStatusMessage("");
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     setStatusMessage("");
// //     setIsSubmitting(true);

// //     // Client-side validation
// //     if (formData.password !== formData.confirmPassword) {
// //       setStatusMessage("Passwords do not match.");
// //       setIsSubmitting(false);
// //       return;
// //     }
// //     if (formData.email !== formData.confirmEmail) {
// //       setStatusMessage("Emails do not match.");
// //       setIsSubmitting(false);
// //       return;
// //     }

// //     try {
// //       const response = await fetch(`${WebApiURL}Verification/register`, {
// //         method: "POST",
// //         headers: { "Content-Type": "application/json" },
// //         body: JSON.stringify(formData)
// //       });

// //       const data = await response.json(); // safe now, backend returns JSON

// //       if (response.ok) {
// //         setStatusMessage("Registration successful! OTP sent to your email.");
// //         handleClear();
// //         setActiveForm("verify"); // switch to OTP verification
// //       } else {
// //         setStatusMessage(data.message || "Registration failed.");
// //       }
// //     } catch (error) {
// //       console.error(error);
// //       setStatusMessage("Server error or network issue.");
// //     } finally {
// //       setIsSubmitting(false);
// //     }
// //   };

// //   return (
// // <>
// // <div className="max-716 w-100 rounded-1 border p-4">
// // <div className="font-24 font-700 mb-4 text-center text-primary-green text-uppercase border-bottom pb-2">
// //           Register
// // </div>

// //         {statusMessage && (
// // <div
// //             className={`alert ${
// //               statusMessage.includes("successful") ? "alert-success" : "alert-danger"
// //             }`}
// // >
// //             {statusMessage}
// // </div>
// //         )}

// //         <form onSubmit={handleSubmit} className="row g-3">
// //           {[
// //             { label: "Surname", name: "surname" },
// //             { label: "Full Name", name: "fullName" },
// //             { label: "Email", name: "email", type: "email" },
// //             { label: "Confirm Email", name: "confirmEmail", type: "email" },
// //             { label: "Designation", name: "designation" },
// //             { label: "Organization Type", name: "organizationType" },
// //             { label: "Organization", name: "organization" },
// //             { label: "Password", name: "password", type: "password" },
// //             { label: "Confirm Password", name: "confirmPassword", type: "password" }
// //           ].map((field) => (
// // <div className="col-12" key={field.name}>
// // <div className="row align-items-center">
// // <div className="col-md-4">
// // <label className="form-label font-17 font-400 text-primary-green mb-0">
// //                     {field.label}
// // </label>
// // </div>
// // <div className="col-md-8">
// // <input
// //                     type={field.type || "text"}
// //                     className="form-control height-40 rounded-1 border-color-7D9199"
// //                     name={field.name}
// //                     value={formData[field.name]}
// //                     onChange={handleInputChange}
// //                     required
// //                   />
// // </div>
// // </div>
// // </div>
// //           ))}

// //           <div className="col-12">
// // <div className="row align-items-center">
// // <div className="col-md-4"></div>
// // <div className="col-md-8">
// // <div className="px-3 py-3 border-custom border-color-7D9199 rounded-1">
// // <div className="form-check">
// // <input
// //                       className="form-check-input"
// //                       type="checkbox"
// //                       name="notRobot"
// //                       id="notRobot"
// //                       checked={formData.notRobot}
// //                       onChange={handleInputChange}
// //                       required
// //                     />
// // <label
// //                       className="form-check-label text-primary-green font-400"
// //                       htmlFor="notRobot"
// // >
// //                       I'm Not A Robot
// // </label>
// // </div>
// // </div>
// // </div>
// // </div>
// // </div>

// //           <div className="col-12">
// // <div className="row align-items-center">
// // <div className="col-md-4"></div>
// // <div className="col-md-8">
// // <div className="row">
// // <div className="col-auto">
// // <button
// //                       type="submit"
// //                       className="btn btn-primary-green height-50 max-165 px-5 text-white w-100 fw-normal rounded-1"
// //                       disabled={isSubmitting}
// // >
// //                       {isSubmitting ? "Submitting..." : "Submit"}
// // </button>
// // </div>
// // <div className="col-auto">
// // <button
// //                       type="button"
// //                       className="btn btn-outline-primary-green height-50 max-165 px-5 w-100 fw-normal rounded-1"
// //                       onClick={handleClear}
// // >
// //                       Clear
// // </button>
// // </div>
// // <div className="col-auto">
// // <button
// //                       type="button"
// //                       className="btn height-50 px-2 border-0 fw-normal rounded-1"
// //                       onClick={() => setActiveForm("login")}
// // >
// //                       Back
// // </button>
// // </div>
// // </div>
// // </div>
// // </div>
// // </div>
// // </form>
// // </div>
// // </>
// //   );
// // }

// // export default RegisterForm;





// import React, { useState } from "react";
// import { WebApiURL } from "../Constants/Constants";
// import OtpVerifyForm from "./OtpVerifyForm";

// function RegisterForm({ setActiveForm }) {
//   const [formData, setFormData] = useState({
//     surname: "",
//     fullName: "",
//     email: "",
//     confirmEmail: "",
//     designation: "",
//     organizationType: "",
//     organization: "",
//     password: "",
//     confirmPassword: "",
//     notRobot: false,
//   });

//   const [statusMessage, setStatusMessage] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [showOtp, setShowOtp] = useState(false);

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const handleClear = () => {
//     setFormData({
//       surname: "",
//       fullName: "",
//       email: "",
//       confirmEmail: "",
//       designation: "",
//       organizationType: "",
//       organization: "",
//       password: "",
//       confirmPassword: "",
//       notRobot: false,
//     });
//     setStatusMessage("");
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatusMessage("");
//     setIsSubmitting(true);

//     if (formData.password !== formData.confirmPassword) {
//       setStatusMessage("Passwords do not match.");
//       setIsSubmitting(false);
//       return;
//     }
//     if (formData.email !== formData.confirmEmail) {
//       setStatusMessage("Emails do not match.");
//       setIsSubmitting(false);
//       return;
//     }

//     try {
//       const response = await fetch(`${WebApiURL}Verification/register`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(formData),
//       });

//       // ✅ Always read as text first
//       const text = await response.text();
//       let data;
//       try {
//         data = JSON.parse(text);
//       } catch {
//         data = { message: text }; // fallback to plain text
//       }

//       if (response.ok) {
//         // Save temp data for OTP verification
//         if (data.userId) {
//           localStorage.setItem("userId", data.userId);
//         }
//         localStorage.setItem("email", formData.email);

//         setStatusMessage("Registration successful! OTP sent to your email.");
//         handleClear();
//         setShowOtp(true); // Show OTP verification screen
//       } else {
//         setStatusMessage(data.message || "Registration failed.");
//       }
//     } catch (error) {
//       console.error(error);
//       setStatusMessage("Server error or network issue.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   if (showOtp) {
//     return <OtpVerifyForm setActiveForm={setActiveForm} source="register" />;
//   }

//   return (
//     <div className="max-716 w-100 rounded-1 border p-4">
//       <div className="font-24 font-700 mb-4 text-center text-primary-green text-uppercase border-bottom pb-2">
//         Register
//       </div>

//       {statusMessage && (
//         <div
//           className={`alert ${statusMessage.includes("successful") ? "alert-success" : "alert-danger"
//             }`}
//         >
//           {statusMessage}
//         </div>
//       )}

//       <form onSubmit={handleSubmit} className="row g-3">
//         {[
//           { label: "Surname", name: "surname" },
//           { label: "Full Name", name: "fullName" },
//           { label: "Email", name: "email", type: "email" },
//           { label: "Confirm Email", name: "confirmEmail", type: "email" },
//           { label: "Designation", name: "designation" },
//           { label: "Organization Type", name: "organizationType" },
//           { label: "Organization", name: "organization" },
//           { label: "Password", name: "password", type: "password" },
//           { label: "Confirm Password", name: "confirmPassword", type: "password" },
//         ].map((field) => (
//           <div className="col-12" key={field.name}>
//             <div className="row align-items-center">
//               <div className="col-md-4">
//                 <label className="form-label font-17 font-400 text-primary-green mb-0">
//                   {field.label}
//                 </label>
//               </div>
//               <div className="col-md-8">
//                 <input
//                   type={field.type || "text"}
//                   className="form-control height-40 rounded-1 border-color-7D9199"
//                   name={field.name}
//                   value={formData[field.name]}
//                   onChange={handleInputChange}
//                   required
//                 />
//               </div>
//             </div>
//           </div>
//         ))}

//         <div className="col-12">
//           <div className="row align-items-center">
//             <div className="col-md-4"></div>
//             <div className="col-md-8">
//               <div className="px-3 py-3 border-custom border-color-7D9199 rounded-1">
//                 <div className="form-check">
//                   <input
//                     className="form-check-input"
//                     type="checkbox"
//                     name="notRobot"
//                     id="notRobot"
//                     checked={formData.notRobot}
//                     onChange={handleInputChange}
//                     required
//                   />
//                   <label
//                     className="form-check-label text-primary-green font-400"
//                     htmlFor="notRobot"
//                   >
//                     I'm Not A Robot
//                   </label>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="col-12">
//           <div className="row align-items-center">
//             <div className="col-md-4"></div>
//             <div className="col-md-8">
//               <div className="row">
//                 <div className="col-auto">
//                   <button
//                     type="submit"
//                     className="btn btn-primary-green height-50 max-165 px-5 text-white w-100 fw-normal rounded-1"
//                     disabled={isSubmitting}
//                   >
//                     {isSubmitting ? "Submitting..." : "Submit"}
//                   </button>
//                 </div>
//                 <div className="col-auto">
//                   <button
//                     type="button"
//                     className="btn btn-outline-primary-green height-50 max-165 px-5 w-100 fw-normal rounded-1"
//                     onClick={handleClear}
//                   >
//                     Clear
//                   </button>
//                 </div>
//                 <div className="col-auto">
//                   <button
//                     type="button"
//                     className="btn height-50 px-2 border-0 fw-normal rounded-1"
//                     onClick={() => setActiveForm("login")}
//                   >
//                     Back
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </form>
//     </div>
//   );
// }

// export default RegisterForm;


import React, { useState } from "react";
import { WebApiURL } from "../Constants/Constants";
import RegisterConfirm from "../Pages/RegisterConfirm"
import OtpRegisterForm from "../Pages/OtpRegisterForm"

function RegisterForm({ setActiveForm }) {

  const [formData, setFormData] = useState({

    surname: "",

    fullName: "",

    email: "",

    confirmEmail: "",

    designation: "",

    organizationType: "",

    organization: "",

    password: "",

    confirmPassword: "",

    notRobot: false,

  });

  const [statusMessage, setStatusMessage] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [showOtp, setShowOtp] = useState(false);

  const handleInputChange = (e) => {

    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({

      ...prev,

      [name]: type === "checkbox" ? checked : value,

    }));

  };

  const handleClear = () => {

    setFormData({

      surname: "",

      fullName: "",

      email: "",

      confirmEmail: "",

      designation: "",

      organizationType: "",

      organization: "",

      password: "",

      confirmPassword: "",

      notRobot: false,

    });

    setStatusMessage("");

  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    setStatusMessage("");

    setIsSubmitting(true);

    if (formData.password !== formData.confirmPassword) {

      setStatusMessage("Passwords do not match.");

      setIsSubmitting(false);

      return;

    }

    if (formData.email !== formData.confirmEmail) {

      setStatusMessage("Emails do not match.");

      setIsSubmitting(false);

      return;

    }

    try {

      const response = await fetch(`${WebApiURL}Verification/register`, {

        method: "POST",

        headers: { "Content-Type": "application/json" },

        body: JSON.stringify(formData),

      });

      // ✅ Always read as text first

      const text = await response.text();

      let data;

      try {

        data = JSON.parse(text);

      } catch {

        data = { message: text }; // fallback to plain text

      }

      if (response.ok) {

        // Save temp data for OTP verification

        if (data.userId) {

          localStorage.setItem("userId", data.userId);

        }

        localStorage.setItem("email", formData.email);

        setStatusMessage("Registration successful!.");

        handleClear();

        setShowOtp(true); // Show OTP verification screen

      } else {

        setStatusMessage(data.message || "Registration failed.");

      }

    } catch (error) {

      console.error(error);

      setStatusMessage("Server error or network issue.");

    } finally {

      setIsSubmitting(false);

    }

  };

  if (showOtp) {

    return <OtpRegisterForm setActiveForm={setActiveForm} source="register" />;

  }

  return (
    <div className="max-716 w-100 rounded-1 border p-4">
      <div className="font-24 font-700 mb-4 text-center text-primary-green text-uppercase border-bottom pb-2">

        Register
      </div>

      {statusMessage && (
        <div

          className={`alert ${statusMessage.includes("successful") ? "alert-success" : "alert-danger"

            }`}
        >

          {statusMessage}
        </div>

      )}

      <form onSubmit={handleSubmit} className="row g-3">

        {[

          { label: "Surname", name: "surname" },

          { label: "Full Name", name: "fullName" },

          { label: "Email", name: "email", type: "email" },

          { label: "Confirm Email", name: "confirmEmail", type: "email" },

          { label: "Designation", name: "designation" },

          { label: "Organization Type", name: "organizationType" },

          { label: "Organization", name: "organization" },

          { label: "Password", name: "password", type: "password" },

          { label: "Confirm Password", name: "confirmPassword", type: "password" },

        ].map((field) => (
          <div className="col-12" key={field.name}>
            <div className="row align-items-center">
              <div className="col-md-4">
                <label className="form-label font-17 font-400 text-primary-green mb-0">

                  {field.label}
                </label>
              </div>
              <div className="col-md-8">
                <input

                  type={field.type || "text"}

                  className="form-control height-40 rounded-1 border-color-7D9199"

                  name={field.name}

                  value={formData[field.name]}

                  onChange={handleInputChange}

                  required

                />
              </div>
            </div>
          </div>

        ))}

        <div className="col-12">
          <div className="row align-items-center">
            <div className="col-md-4"></div>
            <div className="col-md-8">
              <div className="px-3 py-3 border-custom border-color-7D9199 rounded-1">
                <div className="form-check">
                  <input

                    className="form-check-input"

                    type="checkbox"

                    name="notRobot"

                    id="notRobot"

                    checked={formData.notRobot}

                    onChange={handleInputChange}

                    required

                  />
                  <label

                    className="form-check-label text-primary-green font-400"

                    htmlFor="notRobot"
                  >

                    I'm Not A Robot
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12">
          <div className="row align-items-center">
            <div className="col-md-4"></div>
            <div className="col-md-8">
              <div className="row">
                <div className="col-auto">
                  <button

                    type="submit"

                    className="btn btn-primary-green height-50 max-165 px-5 text-white w-100 fw-normal rounded-1"

                    disabled={isSubmitting}
                  >

                    {isSubmitting ? "Submitting..." : "Submit"}
                  </button>
                </div>
                <div className="col-auto">
                  <button

                    type="button"

                    className="btn btn-outline-primary-green height-50 max-165 px-5 w-100 fw-normal rounded-1"

                    onClick={handleClear}
                  >

                    Clear
                  </button>
                </div>
                <div className="col-auto">
                  <button

                    type="button"

                    className="btn height-50 px-2 border-0 fw-normal rounded-1"

                    onClick={() => setActiveForm("login")}
                  >

                    Back
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

  );

}

export default RegisterForm;

